/**
 * Hytropics DRS System v6.1
 * Fixes: cart page initial sync + stronger pack detection
 */
(function () {
  'use strict';

  const DEPOSITS = {
    "12": 52191048434007,
    "24": 52191048466775,
    "36": 52191048499543
  };

  const DEPOSIT_HANDLE = 'deposit-return-scheme';
  const IS_CART_PAGE = window.location.pathname.includes('/cart');

  let syncTimer = null;
  let syncing = false;
  let lastSync = 0;

  function log(msg, data) {
    console.log(`[DRS] ${msg}`, data || '');
  }

  function detectPackSize(item) {
    const text = [
      item.variant_title,
      item.product_title,
      item.title,
      item.url
    ].filter(Boolean).join(' ').toLowerCase();

    if (text.includes('12') && (text.includes('pack') || text.includes('multipack'))) return "12";
    if (text.includes('24') && (text.includes('pack') || text.includes('multipack'))) return "24";
    if (text.includes('36') && (text.includes('pack') || text.includes('multipack'))) return "36";

    return null;
  }

  function calculateNeededDeposits(cart) {
    const counts = { "12": 0, "24": 0, "36": 0 };

    if (!cart.items) return counts;

    cart.items.forEach(item => {
      if (item.product_handle === DEPOSIT_HANDLE) return;
      if (Object.values(DEPOSITS).includes(item.variant_id)) return;

      const pack = detectPackSize(item);

      if (pack && counts[pack] !== undefined) {
        counts[pack] += item.quantity;
      }
    });

    return counts;
  }

  function findDepositLine(cart, variantId) {
    if (!cart.items) return null;

    for (let i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === variantId) {
        return { line: i + 1, qty: cart.items[i].quantity };
      }
    }

    return null;
  }

  async function syncDeposits() {
    const now = Date.now();

    if (now - lastSync < 800) {
      log('Throttled');
      return;
    }

    if (syncing) {
      log('Already syncing');
      return;
    }

    syncing = true;
    lastSync = now;
    log('=== SYNC START ===');

    try {
      await new Promise(r => setTimeout(r, 150));

      const res = await fetch('/cart.js');
      if (!res.ok) throw new Error('Cart fetch failed');

      const cart = await res.json();
      const needed = calculateNeededDeposits(cart);

      log('Needed deposits:', needed);

      let changed = false;

      for (const [pack, targetQty] of Object.entries(needed)) {
        const depositId = DEPOSITS[pack];
        const existing = findDepositLine(cart, depositId);
        const currentQty = existing ? existing.qty : 0;

        if (currentQty === targetQty) continue;

        changed = true;

        if (existing) {
          log(`Update ${pack} pack DRS: ${currentQty} → ${targetQty}`);

          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              line: existing.line,
              quantity: targetQty
            })
          });

        } else if (targetQty > 0) {
          log(`Add ${pack} pack DRS: ${targetQty}`);

          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: depositId,
              quantity: targetQty
            })
          });
        }

        await new Promise(r => setTimeout(r, 100));
      }

      if (changed) {
        await new Promise(r => setTimeout(r, 250));

        if (IS_CART_PAGE) {
          log('Reloading cart page after DRS update');
          window.location.reload();
        } else {
          log('Refreshing drawer after DRS update');

          if (typeof window.refreshCart === 'function') {
            window.refreshCart();
          }
        }
      }

      log('=== SYNC END ===');

    } catch (err) {
      log('ERROR:', err.message);
    } finally {
      syncing = false;
    }
  }

  function scheduleSync(delay = 600) {
    if (syncTimer) clearTimeout(syncTimer);

    syncTimer = setTimeout(() => {
      syncTimer = null;
      syncDeposits();
    }, delay);

    log(`Scheduled in ${delay}ms`);
  }

  function setupCartPage() {
    log('Cart page mode');

    let clickTimeout = null;

    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.qty-button, .qty-plus, .qty-minus, .remove, button, a');

      if (btn) {
        if (clickTimeout) clearTimeout(clickTimeout);

        clickTimeout = setTimeout(() => {
          clickTimeout = null;
          syncDeposits();
        }, 900);
      }
    }, true);

    document.addEventListener('change', (e) => {
      if (e.target.matches('input[name="updates[]"], input[type="number"], select')) {
        scheduleSync(900);
      }
    }, true);
  }

  function setupDrawer() {
    log('Drawer mode');

    const originalRefreshCart = window.refreshCart;

    if (originalRefreshCart) {
      window.refreshCart = function () {
        if (IS_CART_PAGE) {
          originalRefreshCart.apply(this, arguments);
          return;
        }

        originalRefreshCart.apply(this, arguments);
        scheduleSync(500);
      };
    }

    const cartForm = document.getElementById('AjaxCartForm');

    if (cartForm) {
      const observer = new MutationObserver(() => {
        scheduleSync(600);
      });

      observer.observe(cartForm, {
        childList: true,
        subtree: true,
        attributes: false
      });
    }
  }

  function init() {
    log(`DRS v6.1 - ${IS_CART_PAGE ? 'CART PAGE' : 'DRAWER'} mode`);

    if (IS_CART_PAGE) {
      setupCartPage();
      scheduleSync(800);
    } else {
      setupDrawer();
      scheduleSync(800);
    }

    log('Ready');
  }

  window.DEPOSIT = {
    sync: () => scheduleSync(300),
    syncNow: syncDeposits,
    version: '6.1-cart-page-fix'
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();